export enum CustomerDispatchRuleScope {
    ProductType = 'PRODUCT_TYPE',
    VehicleType = 'VEHICLE_TYPE',
    Destination = 'DESTINATION',
    Lane = 'LANE',
}